import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import {useDeleteOrganizationMutation} from 'api';
import {useSnackbar} from 'notistack';

function OrganizationDeleteIconButton({organizationId}) {
  const [deleteOrganization, deleteOrganizationResult] = useDeleteOrganizationMutation();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const {enqueueSnackbar} = useSnackbar();

  const handleDelete = async () => {
    try {
      await deleteOrganization(organizationId).unwrap();
      enqueueSnackbar('Organization deleted', {variant: 'success'});
      setIsModalOpen(false);
    } catch (error) {
      const message = error.status === 400 ? error.data?.details?.[0]?.message : undefined;
      enqueueSnackbar(message || `Error deleting Organization`, {variant: 'error'});
    }
  };

  return (
    <>
      <Dialog open={isModalOpen} maxWidth="xs">
        <DialogTitle>Delete Organization</DialogTitle>
        <DialogContent dividers>Are you sure you want to delete this Organization?</DialogContent>
        <DialogActions>
          <Button
            disabled={deleteOrganization.isLoading}
            autoFocus
            onClick={() => setIsModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            disabled={deleteOrganizationResult.isLoading}
            color="error"
            endIcon={deleteOrganizationResult.isLoading ? <CircularProgress size={16} /> : null}
            onClick={handleDelete}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton
        onClick={() => setIsModalOpen(true)}
        disabled={deleteOrganizationResult.isLoading}
        aria-label="delete"
        color="error"
      >
        <DeleteIcon />
      </IconButton>
    </>
  );
}

export default OrganizationDeleteIconButton;
